import { gql } from 'graphql-tag';
import { TypedDocumentNode } from '@apollo/client';

import { UpsertConsent, UpsertConsentVariables } from '@generated/graphql';

export const upsertConsent: TypedDocumentNode<UpsertConsent, UpsertConsentVariables> = gql`
  mutation UpsertConsent($input: UpsertConsentMutationInput!) {
    upsertConsent(input: $input) {
      userErrors {
        path
        message
      }
    }
  }
`;
